<img [src]="employee.pictureLink ? employee.pictureLink : './assets/images/default-user-image.svg'" alt="" [ngClass]="size" />
<span>{{ employee | fullName }}</span>
